// import React from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import authService from "../services/authService";

// const Sidebar = ({ isOpen, closeMobileSidebar }) => {
//   const navigate = useNavigate();
//   const user = authService.getCurrentUser();
//   const role = user?.role || "PLAYER";

//   const handleLogout = () => {
//     authService.logout();
//     toast.info("Logged out successfully.");
//     navigate("/login");
//   };

//   const navItemsByRole = {
//     SUPER_ADMIN: [
//       { title: "Dashboard", path: "/dashboard", icon: "bi-grid-1x2-fill" },
//       { title: "Dealers", path: "/dealers", icon: "bi-people-fill" },
//       { title: "Hierarchy", path: "/hierarchy", icon: "bi-diagram-3-fill" },
//       { title: "Transfer to Dealer", path: "/transfer-dealer", icon: "bi-arrow-left-right" },
//       { title: "Reports", path: "/reports", icon: "bi-bar-chart-fill" },
//       { title: "Settings", path: "/settings", icon: "bi-gear-fill" }
//     ],
//     DEALER: [
//       { title: "Dashboard", path: "/dashboard", icon: "bi-grid-1x2-fill" },
//       { title: "Shops", path: "/shops", icon: "bi-shop" },
//       { title: "Transfer to Shop", path: "/transfer-shop", icon: "bi-arrow-left-right" },
//       { title: "Reports", path: "/reports", icon: "bi-bar-chart-fill" },
//       { title: "Settings", path: "/settings", icon: "bi-gear-fill" }
//     ],
//     SHOP: [
//       { title: "Dashboard", path: "/dashboard", icon: "bi-grid-1x2-fill" },
//       { title: "Players", path: "/players", icon: "bi-person-badge-fill" },
//       { title: "Transfer to Player", path: "/transfer-player", icon: "bi-arrow-left-right" },
//       { title: "Pending Winners", path: "/pending-winners", icon: "bi-trophy-fill" },
//       { title: "Reports", path: "/reports", icon: "bi-bar-chart-fill" },
//       { title: "Settings", path: "/settings", icon: "bi-gear-fill" }
//     ],
//     PLAYER: [
//       { title: "Dashboard", path: "/dashboard", icon: "bi-grid-1x2-fill" },
//       { title: "Current Game", path: "/game", icon: "bi-controller" },
//       { title: "Bet History", path: "/bet-history", icon: "bi-clock-history" },
//       { title: "Wallet History", path: "/wallet-history", icon: "bi-wallet2" },
//       { title: "Settings", path: "/settings", icon: "bi-gear-fill" }
//     ]
//   };

//   const navItems = navItemsByRole[role] || navItemsByRole.PLAYER;
//   const roleLabel = role.replaceAll("_", " ");

//   return (
//     <>
//       {isOpen && <button className="sidebar-backdrop d-md-none" onClick={closeMobileSidebar} aria-label="Close sidebar" />}
//       <aside className={`app-sidebar ${isOpen ? "open" : ""}`}>
//         <div>
//           <div className="sidebar-section-label">{roleLabel}</div>
//           <ul className="nav flex-column sidebar-nav">
//             {navItems.map((item) => (
//               <li key={item.path} className="nav-item">
//                 <NavLink
//                   to={item.path}
//                   onClick={closeMobileSidebar}
//                   className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
//                 >
//                   <span className="sidebar-icon"><i className={`bi ${item.icon}`} /></span>
//                   <span>{item.title}</span>
//                   <i className="bi bi-chevron-right sidebar-chevron" />
//                 </NavLink>
//               </li>
//             ))}
//           </ul>
//         </div>

//         <div className="sidebar-footer">
//           <div className="sidebar-status">
//             <span className="status-dot" />
//             <span>System online</span>
//           </div>
//           <button onClick={handleLogout} className="sidebar-logout d-md-none" type="button">
//             <i className="bi bi-box-arrow-left" /> Logout
//           </button>
//         </div>
//       </aside>
//     </>
//   );
// };

// export default Sidebar;










// import React from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import authService from "../services/authService";

// const Sidebar = ({ isOpen, closeMobileSidebar }) => {
//   const navigate = useNavigate();
//   const user = authService.getCurrentUser();

//   const role = user?.role || "PLAYER";
//   const roleLabel = role.replaceAll("_", " ");

//   const handleLogout = () => {
//     authService.logout();
//     toast.info("Logged out successfully.");
//     navigate("/login");
//   };

//   const navItemsByRole = {
//     SUPER_ADMIN: [
//       { title: "Dashboard", path: "/dashboard", icon: "bi-grid-fill" },
//       { title: "Dealers", path: "/dealers", icon: "bi-people-fill" },
//       { title: "Hierarchy", path: "/hierarchy", icon: "bi-diagram-3-fill" },
//       { title: "Transfer to Dealer", path: "/transfer-dealer", icon: "bi-arrow-left-right" },
//       { title: "Reports", path: "/reports", icon: "bi-bar-chart-fill" },
//       { title: "Settings", path: "/settings", icon: "bi-gear-fill" },
//     ],

//     DEALER: [
//       { title: "Dashboard", path: "/dashboard", icon: "bi-grid-fill" },
//       { title: "Shops", path: "/shops", icon: "bi-shop" },
//       { title: "Transfer to Shop", path: "/transfer-shop", icon: "bi-arrow-left-right" },
//       { title: "Reports", path: "/reports", icon: "bi-bar-chart-fill" },
//       { title: "Settings", path: "/settings", icon: "bi-gear-fill" },
//     ],

// SHOP: [
//   { title: "Dashboard", path: "/dashboard", icon: "bi-grid-fill" },

//   // OLD PLAYER MODULE - abhi compatibility ke liye rehne do
//   { title: "Players", path: "/players", icon: "bi-person-badge-fill" },
//   { title: "Transfer to Player", path: "/transfer-player", icon: "bi-arrow-left-right" },
//   { title: "Pending Winners", path: "/pending-winners", icon: "bi-trophy-fill" },

//   { title: "Reports", path: "/reports", icon: "bi-bar-chart-fill" },
//   { title: "Settings", path: "/settings", icon: "bi-gear-fill" },
// ],

//     PLAYER: [
//       { title: "Dashboard", path: "/dashboard", icon: "bi-grid-fill" },
//       { title: "Current Game", path: "/game", icon: "bi-controller" },
//       { title: "Bet History", path: "/bet-history", icon: "bi-clock-history" },
//       { title: "Wallet History", path: "/wallet-history", icon: "bi-wallet2" },
//       { title: "Settings", path: "/settings", icon: "bi-gear-fill" },
//     ],
//   };

//   const navItems = navItemsByRole[role] || navItemsByRole.PLAYER;

//   return (
//     <>
//       {isOpen && (
//         <button
//           type="button"
//           onClick={closeMobileSidebar}
//           className="fixed inset-0 z-40 bg-black/70 md:hidden"
//           aria-label="Close sidebar"
//         />
//       )}

//       <aside
//         className={`
//           fixed left-0 top-[68px] z-50
//           flex h-[calc(100vh-68px)] w-[248px] flex-col
//           border-r border-[rgba(148,163,184,0.14)]
//           bg-[#0D111C]
//           text-[#F8FAFC]
//           transition-transform duration-300

//           md:sticky md:top-[68px] md:z-20 md:translate-x-0 md:shrink-0 md:self-start

//           ${isOpen ? "translate-x-0" : "-translate-x-full"}
//         `}
//       >
//         {/* Mobile Close Button bar */}
//         <div className="flex items-center justify-end px-3 py-2 border-b border-[rgba(148,163,184,0.14)] md:hidden">
//           <button
//             type="button"
//             onClick={closeMobileSidebar}
//             className="flex h-8 w-8 items-center justify-center rounded-lg text-[#94A3B8] transition hover:bg-white/5 hover:text-[#F8FAFC]"
//             aria-label="Close sidebar"
//           >
//             <i className="bi bi-x-lg" />
//           </button>
//         </div>

//         {/* Navigation */}
//         <div className="flex-1 overflow-y-auto px-3 py-4">
//           <p className="mb-3 px-3 text-[10px] font-bold uppercase tracking-[0.2em] text-[#64748B]">
//             {roleLabel} NAVIGATION
//           </p>

//           <nav className="space-y-1">
//             {navItems.map((item) => (
//               <NavLink
//                 key={item.path}
//                 to={item.path}
//                 onClick={closeMobileSidebar}
//                 className={({ isActive }) =>
//                   `
//                   group flex items-center gap-3 rounded-lg
//                   px-3 py-2.5 text-xs font-semibold transition-all duration-150

//                   ${isActive
//                     ? "bg-[#D4AF37]/12 text-[#D4AF37] border-l-2 border-[#D4AF37]"
//                     : "text-[#94A3B8] hover:bg-white/5 hover:text-[#F8FAFC]"
//                   }
//                 `
//                 }
//               >
//                 {({ isActive }) => (
//                   <>
//                     <span
//                       className={`
//                         flex h-7 w-7 items-center justify-center rounded-md
//                         transition-colors text-sm
//                         ${isActive
//                           ? "text-[#D4AF37]"
//                           : "text-[#94A3B8] group-hover:text-[#F8FAFC]"
//                         }
//                       `}
//                     >
//                       <i className={`bi ${item.icon}`} />
//                     </span>

//                     <span className="flex-1 tracking-wide">
//                       {item.title}
//                     </span>

//                     <i
//                       className={`bi bi-chevron-right text-[10px] ${isActive
//                           ? "text-[#D4AF37]"
//                           : "text-[#64748B] group-hover:text-[#94A3B8]"
//                         }`}
//                     />
//                   </>
//                 )}
//               </NavLink>
//             ))}
//           </nav>
//         </div>

//         {/* Footer */}
//         <div className="border-t border-[rgba(148,163,184,0.14)] p-3">
          

//           <button
//             type="button"
//             onClick={handleLogout}
//             className="flex w-full items-center justify-center gap-2 rounded-lg bg-red-500/10 border border-red-500/20 px-3 py-2 text-xs font-semibold text-red-400 transition hover:bg-red-500/20 hover:text-red-300"
//           >
//             <i className="bi bi-box-arrow-left" />
//             Logout
//           </button>
//         </div>
//       </aside>
//     </>
//   );
// };

// export default Sidebar;







// import React from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import authService from "../services/authService";

// const Sidebar = ({ isOpen, closeMobileSidebar }) => {
//   const navigate = useNavigate();
//   const user = authService.getCurrentUser();

//   const role = user?.role || "PLAYER";
//   const roleLabel = role.replaceAll("_", " ");

//   // ============================================================
//   // LOGOUT
//   // ============================================================

//   const handleLogout = () => {
//     authService.logout();
//     toast.info("Logged out successfully.");
//     navigate("/login");
//   };

//   // ============================================================
//   // ROLE BASED NAVIGATION
//   // ============================================================

//   const navItemsByRole = {
//     // ==========================================================
//     // SUPER ADMIN
//     // ==========================================================

//     SUPER_ADMIN: [
//       {
//         title: "Dashboard",
//         path: "/dashboard",
//         icon: "bi-grid-fill",
//       },
//       {
//         title: "Dealers",
//         path: "/dealers",
//         icon: "bi-people-fill",
//       },
//       {
//         title: "Hierarchy",
//         path: "/hierarchy",
//         icon: "bi-diagram-3-fill",
//       },
//       {
//         title: "Transfer to Dealer",
//         path: "/transfer-dealer",
//         icon: "bi-arrow-left-right",
//       },
//       {
//         title: "Reports",
//         path: "/reports",
//         icon: "bi-bar-chart-fill",
//       },
//       {
//         title: "Settings",
//         path: "/settings",
//         icon: "bi-gear-fill",
//       },
//     ],

//     // ==========================================================
//     // DEALER
//     // ==========================================================

//     DEALER: [
//       {
//         title: "Dashboard",
//         path: "/dashboard",
//         icon: "bi-grid-fill",
//       },
//       {
//         title: "Shops",
//         path: "/shops",
//         icon: "bi-shop",
//       },
//       {
//         title: "Transfer to Shop",
//         path: "/transfer-shop",
//         icon: "bi-arrow-left-right",
//       },
//       {
//         title: "Reports",
//         path: "/reports",
//         icon: "bi-bar-chart-fill",
//       },
//       {
//         title: "Settings",
//         path: "/settings",
//         icon: "bi-gear-fill",
//       },
//     ],

//     // ==========================================================
//     // SHOP
//     // ==========================================================

//     SHOP: [
//       {
//         title: "Dashboard",
//         path: "/dashboard",
//         icon: "bi-grid-fill",
//       },

//       // NEW COMPUTER MANAGEMENT
//       {
//         title: "Computers",
//         path: "/computers",
//         icon: "bi-pc-display",
//       },

//       // OLD PLAYER MODULE
//       // Compatibility ke liye abhi rehne diya hai
//       {
//         title: "Players",
//         path: "/players",
//         icon: "bi-person-badge-fill",
//       },
//       {
//         title: "Transfer to Player",
//         path: "/transfer-player",
//         icon: "bi-arrow-left-right",
//       },
//       {
//         title: "Pending Winners",
//         path: "/pending-winners",
//         icon: "bi-trophy-fill",
//       },
//       {
//         title: "Reports",
//         path: "/reports",
//         icon: "bi-bar-chart-fill",
//       },
//       {
//         title: "Settings",
//         path: "/settings",
//         icon: "bi-gear-fill",
//       },
//     ],

//     // ==========================================================
//     // PLAYER
//     // ==========================================================

//     PLAYER: [
//       {
//         title: "Dashboard",
//         path: "/dashboard",
//         icon: "bi-grid-fill",
//       },
//       {
//         title: "Current Game",
//         path: "/game",
//         icon: "bi-controller",
//       },
//       {
//         title: "Bet History",
//         path: "/bet-history",
//         icon: "bi-clock-history",
//       },
//       {
//         title: "Wallet History",
//         path: "/wallet-history",
//         icon: "bi-wallet2",
//       },
//       {
//         title: "Settings",
//         path: "/settings",
//         icon: "bi-gear-fill",
//       },
//     ],
//   };

//   // ============================================================
//   // GET CURRENT ROLE NAVIGATION
//   // ============================================================

//   const navItems =
//     navItemsByRole[role] ||
//     navItemsByRole.PLAYER;

//   // ============================================================
//   // UI
//   // ============================================================

//   return (
//     <>
//       {/* ====================================================== */}
//       {/* MOBILE BACKDROP */}
//       {/* ====================================================== */}

//       {isOpen && (
//         <button
//           type="button"
//           onClick={closeMobileSidebar}
//           className="fixed inset-0 z-40 bg-black/70 md:hidden"
//           aria-label="Close sidebar"
//         />
//       )}

//       {/* ====================================================== */}
//       {/* SIDEBAR */}
//       {/* ====================================================== */}

//       <aside
//         className={`
//           fixed left-0 top-[68px] z-50
//           flex h-[calc(100vh-68px)] w-[248px] flex-col
//           border-r border-[rgba(148,163,184,0.14)]
//           bg-[#0D111C]
//           text-[#F8FAFC]
//           transition-transform duration-300

//           md:sticky
//           md:top-[68px]
//           md:z-20
//           md:translate-x-0
//           md:shrink-0
//           md:self-start

//           ${
//             isOpen
//               ? "translate-x-0"
//               : "-translate-x-full"
//           }
//         `}
//       >
//         {/* ==================================================== */}
//         {/* MOBILE CLOSE BUTTON */}
//         {/* ==================================================== */}

//         <div className="flex items-center justify-end border-b border-[rgba(148,163,184,0.14)] px-3 py-2 md:hidden">
//           <button
//             type="button"
//             onClick={closeMobileSidebar}
//             className="flex h-8 w-8 items-center justify-center rounded-lg text-[#94A3B8] transition hover:bg-white/5 hover:text-[#F8FAFC]"
//             aria-label="Close sidebar"
//           >
//             <i className="bi bi-x-lg" />
//           </button>
//         </div>

//         {/* ==================================================== */}
//         {/* NAVIGATION */}
//         {/* ==================================================== */}

//         <div className="flex-1 overflow-y-auto px-3 py-4">
//           <p className="mb-3 px-3 text-[10px] font-bold uppercase tracking-[0.2em] text-[#64748B]">
//             {roleLabel} NAVIGATION
//           </p>

//           <nav className="space-y-1">
//             {navItems.map((item) => (
//               <NavLink
//                 key={item.path}
//                 to={item.path}
//                 onClick={closeMobileSidebar}
//                 className={({ isActive }) =>
//                   `
//                     group flex items-center gap-3
//                     rounded-lg
//                     px-3 py-2.5
//                     text-xs font-semibold
//                     transition-all duration-150

//                     ${
//                       isActive
//                         ? "bg-[#D4AF37]/12 text-[#D4AF37] border-l-2 border-[#D4AF37]"
//                         : "text-[#94A3B8] hover:bg-white/5 hover:text-[#F8FAFC]"
//                     }
//                   `
//                 }
//               >
//                 {({ isActive }) => (
//                   <>
//                     {/* ICON */}

//                     <span
//                       className={`
//                         flex h-7 w-7
//                         items-center
//                         justify-center
//                         rounded-md
//                         text-sm
//                         transition-colors

//                         ${
//                           isActive
//                             ? "text-[#D4AF37]"
//                             : "text-[#94A3B8] group-hover:text-[#F8FAFC]"
//                         }
//                       `}
//                     >
//                       <i
//                         className={`bi ${item.icon}`}
//                       />
//                     </span>

//                     {/* TITLE */}

//                     <span className="flex-1 tracking-wide">
//                       {item.title}
//                     </span>

//                     {/* ARROW */}

//                     <i
//                       className={`
//                         bi bi-chevron-right
//                         text-[10px]

//                         ${
//                           isActive
//                             ? "text-[#D4AF37]"
//                             : "text-[#64748B] group-hover:text-[#94A3B8]"
//                         }
//                       `}
//                     />
//                   </>
//                 )}
//               </NavLink>
//             ))}
//           </nav>
//         </div>

//         {/* ==================================================== */}
//         {/* FOOTER */}
//         {/* ==================================================== */}

//         <div className="border-t border-[rgba(148,163,184,0.14)] p-3">
//           <button
//             type="button"
//             onClick={handleLogout}
//             className="
//               flex w-full
//               items-center
//               justify-center
//               gap-2
//               rounded-lg
//               border border-red-500/20
//               bg-red-500/10
//               px-3 py-2
//               text-xs
//               font-semibold
//               text-red-400
//               transition
//               hover:bg-red-500/20
//               hover:text-red-300
//             "
//           >
//             <i className="bi bi-box-arrow-left" />

//             Logout
//           </button>
//         </div>
//       </aside>
//     </>
//   );
// };

// export default Sidebar;






import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import authService from "../services/authService";

const Sidebar = ({
  isOpen,
  closeMobileSidebar,
}) => {
  const navigate = useNavigate();

  // ============================================================
  // STAFF SESSION
  // ============================================================

  const staffUser =
    authService.getCurrentUser();

  const staffToken =
    authService.getToken();

  const isStaffLoggedIn =
    Boolean(staffUser) &&
    Boolean(staffToken);

  // ============================================================
  // COMPUTER SESSION
  // ============================================================

  const computerToken =
    sessionStorage.getItem(
      "computer_token"
    );

  let computer = null;

  try {
    const storedComputer =
      sessionStorage.getItem(
        "computer"
      );

    if (storedComputer) {
      computer =
        JSON.parse(storedComputer);
    }
  } catch (error) {
    console.error(
      "Invalid Computer Session:",
      error
    );

    sessionStorage.removeItem(
      "computer_token"
    );

    sessionStorage.removeItem(
      "computer"
    );
  }

  const isComputerLoggedIn =
    Boolean(computerToken) &&
    Boolean(computer);

  // ============================================================
  // CURRENT ROLE
  // ============================================================

  let role = null;

  if (isStaffLoggedIn) {
    role = staffUser.role;
  } else if (isComputerLoggedIn) {
    role = "COMPUTER";
  }

  const roleLabel =
    role?.replaceAll("_", " ") ||
    "USER";

  // ============================================================
  // LOGOUT
  // ============================================================

  const handleLogout = () => {
    // Computer logout
    if (
      role === "COMPUTER"
    ) {
      sessionStorage.removeItem(
        "computer_token"
      );

      sessionStorage.removeItem(
        "computer"
      );

      toast.info(
        "Computer logged out successfully."
      );

      navigate(
        "/login",
        {
          replace: true,
        }
      );

      return;
    }

    // Staff logout
    authService.logout();

    toast.info(
      "Logged out successfully."
    );

    navigate(
      "/login",
      {
        replace: true,
      }
    );
  };

  // ============================================================
  // ROLE BASED NAVIGATION
  // ============================================================

  const navItemsByRole = {
    // ==========================================================
    // SUPER ADMIN
    // ==========================================================

    SUPER_ADMIN: [
      {
        title: "Dashboard",
        path: "/dashboard",
        icon: "bi-grid-fill",
      },
      {
        title: "Dealers",
        path: "/dealers",
        icon: "bi-people-fill",
      },
      {
        title: "Hierarchy",
        path: "/hierarchy",
        icon: "bi-diagram-3-fill",
      },
      {
        title: "Transfer to Dealer",
        path: "/transfer-dealer",
        icon: "bi-arrow-left-right",
      },
      {
        title: "Reports",
        path: "/reports",
        icon: "bi-bar-chart-fill",
      },
      {
        title: "Settings",
        path: "/settings",
        icon: "bi-gear-fill",
      },
    ],

    // ==========================================================
    // DEALER
    // ==========================================================

    DEALER: [
      {
        title: "Dashboard",
        path: "/dashboard",
        icon: "bi-grid-fill",
      },
      {
        title: "Shops",
        path: "/shops",
        icon: "bi-shop",
      },
      {
        title: "Transfer to Shop",
        path: "/transfer-shop",
        icon: "bi-arrow-left-right",
      },
      {
        title: "Reports",
        path: "/reports",
        icon: "bi-bar-chart-fill",
      },
      {
        title: "Settings",
        path: "/settings",
        icon: "bi-gear-fill",
      },
    ],

    // ==========================================================
    // SHOP
    // ==========================================================

    SHOP: [
      {
        title: "Dashboard",
        path: "/dashboard",
        icon: "bi-grid-fill",
      },
      {
        title: "Computers",
        path: "/computers",
        icon: "bi-pc-display",
      },
      {
        title: "Pending Winners",
        path: "/pending-winners",
        icon: "bi-trophy-fill",
      },
      {
        title: "Reports",
        path: "/reports",
        icon: "bi-bar-chart-fill",
      },
      {
        title: "Settings",
        path: "/settings",
        icon: "bi-gear-fill",
      },
    ],

    // ==========================================================
    // PLAYER - LEGACY
    // ==========================================================

    PLAYER: [
      {
        title: "Dashboard",
        path: "/dashboard",
        icon: "bi-grid-fill",
      },
      {
        title: "Current Game",
        path: "/game",
        icon: "bi-controller",
      },
      {
        title: "Bet History",
        path: "/bet-history",
        icon: "bi-clock-history",
      },
      {
        title: "Wallet History",
        path: "/wallet-history",
        icon: "bi-wallet2",
      },
      {
        title: "Settings",
        path: "/settings",
        icon: "bi-gear-fill",
      },
    ],

    // ==========================================================
    // COMPUTER
    // ==========================================================

    COMPUTER: [
      {
        title: "Dashboard",
        path: "/computer-dashboard",
        icon: "bi-grid-fill",
      },
      {
        title: "Game",
        path: "/game",
        icon: "bi-controller",
      },
      {
        title: "History",
        path: "/computer-history",
        icon: "bi-clock-history",
      },
    ],
  };

  // ============================================================
  // GET CURRENT NAVIGATION
  // ============================================================

  const navItems =
    navItemsByRole[role] || [];

  // ============================================================
  // UI
  // ============================================================

  return (
    <>
      {/* ====================================================== */}
      {/* MOBILE BACKDROP */}
      {/* ====================================================== */}

      {isOpen && (
        <button
          type="button"
          onClick={
            closeMobileSidebar
          }
          className="fixed inset-0 z-40 bg-black/70 md:hidden"
          aria-label="Close sidebar"
        />
      )}

      {/* ====================================================== */}
      {/* SIDEBAR */}
      {/* ====================================================== */}

      <aside
        className={`
          fixed left-0 top-[68px] z-50
          flex h-[calc(100vh-68px)] w-[248px] flex-col
          border-r border-[rgba(148,163,184,0.14)]
          bg-[#0D111C]
          text-[#F8FAFC]
          transition-transform duration-300

          md:sticky
          md:top-[68px]
          md:z-20
          md:translate-x-0
          md:shrink-0
          md:self-start

          ${
            isOpen
              ? "translate-x-0"
              : "-translate-x-full"
          }
        `}
      >
        {/* ==================================================== */}
        {/* MOBILE CLOSE */}
        {/* ==================================================== */}

        <div className="flex items-center justify-end border-b border-[rgba(148,163,184,0.14)] px-3 py-2 md:hidden">

          <button
            type="button"
            onClick={
              closeMobileSidebar
            }
            className="flex h-8 w-8 items-center justify-center rounded-lg text-[#94A3B8] transition hover:bg-white/5 hover:text-[#F8FAFC]"
            aria-label="Close sidebar"
          >
            <i className="bi bi-x-lg" />
          </button>

        </div>

        {/* ==================================================== */}
        {/* COMPUTER INFO */}
        {/* ==================================================== */}

        {role === "COMPUTER" &&
          computer && (
            <div className="border-b border-[rgba(148,163,184,0.14)] px-4 py-4">

              <div className="flex items-center gap-3">

                <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-[#D4AF37]/20 bg-[#D4AF37]/10 text-[#D4AF37]">

                  <i className="bi bi-pc-display text-lg" />

                </div>

                <div className="min-w-0">

                  <p className="mb-0 truncate text-xs font-bold text-[#F8FAFC]">
                    {computer.computer_code ||
                      "Computer"}
                  </p>

                  <div className="mt-1 flex items-center gap-1.5">

                    <span className="h-1.5 w-1.5 rounded-full bg-green-400" />

                    <span className="text-[9px] font-bold uppercase tracking-wider text-green-400">
                      {computer.status ||
                        "ACTIVE"}
                    </span>

                  </div>

                </div>

              </div>

            </div>
          )}

        {/* ==================================================== */}
        {/* NAVIGATION */}
        {/* ==================================================== */}

        <div className="flex-1 overflow-y-auto px-3 py-4">

          <p className="mb-3 px-3 text-[10px] font-bold uppercase tracking-[0.2em] text-[#64748B]">
            {roleLabel} NAVIGATION
          </p>

          <nav className="space-y-1">

            {navItems.map(
              (item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={
                    closeMobileSidebar
                  }
                  className={({
                    isActive,
                  }) => `
                    group flex items-center gap-3
                    rounded-lg
                    px-3 py-2.5
                    text-xs font-semibold
                    transition-all duration-150

                    ${
                      isActive
                        ? "bg-[#D4AF37]/12 text-[#D4AF37] border-l-2 border-[#D4AF37]"
                        : "text-[#94A3B8] hover:bg-white/5 hover:text-[#F8FAFC]"
                    }
                  `}
                >
                  {({
                    isActive,
                  }) => (
                    <>
                      {/* ICON */}

                      <span
                        className={`
                          flex h-7 w-7
                          items-center
                          justify-center
                          rounded-md
                          text-sm
                          transition-colors

                          ${
                            isActive
                              ? "text-[#D4AF37]"
                              : "text-[#94A3B8] group-hover:text-[#F8FAFC]"
                          }
                        `}
                      >
                        <i
                          className={`bi ${item.icon}`}
                        />
                      </span>

                      {/* TITLE */}

                      <span className="flex-1 tracking-wide">
                        {item.title}
                      </span>

                      {/* ARROW */}

                      <i
                        className={`
                          bi bi-chevron-right
                          text-[10px]

                          ${
                            isActive
                              ? "text-[#D4AF37]"
                              : "text-[#64748B] group-hover:text-[#94A3B8]"
                          }
                        `}
                      />
                    </>
                  )}
                </NavLink>
              )
            )}

          </nav>

        </div>

        {/* ==================================================== */}
        {/* FOOTER */}
        {/* ==================================================== */}

        <div className="border-t border-[rgba(148,163,184,0.14)] p-3">

          <button
            type="button"
            onClick={handleLogout}
            className="
              flex w-full
              items-center
              justify-center
              gap-2
              rounded-lg
              border border-red-500/20
              bg-red-500/10
              px-3 py-2
              text-xs
              font-semibold
              text-red-400
              transition
              hover:bg-red-500/20
              hover:text-red-300
            "
          >
            <i className="bi bi-box-arrow-left" />

            Logout
          </button>

        </div>

      </aside>
    </>
  );
};

export default Sidebar;